import tabs from "./tabs.json";

export default {
  tabs,
};
